// About.jsx - Updated with black text colors
import React, { useEffect } from 'react'

function About() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <div 
        className="container-fluid bg-primary py-5 mb-5 hero-header"
        style={{
          backgroundImage: 'linear-gradient(rgba(20, 20, 31, 0.35), rgba(20, 20, 31, 0.45)), url("https://images.unsplash.com/photo-1570789210967-2cac24afeb00?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80")',
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          minHeight: '100vh',
          paddingTop: '8rem',
          paddingBottom: '8rem',
          imageRendering: 'crisp-edges',
          WebkitImageRendering: 'crisp-edges',
          transform: 'translateZ(0)',
          backfaceVisibility: 'hidden'
        }}
      >
          {/* Dark overlay - only darkens, does not affect image zoom/position */}
        <div style={{
          position: 'absolute',
          top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.01)',
          zIndex: 0
        }} />
        <div className="container py-5">
          <div className="row justify-content-center py-5">
            <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
              <h1 className="animated slideInDown" style={{ 
                fontFamily: 'Georgia, "Times New Roman", serif',
                fontStyle: 'normal',
                fontWeight: '400',
                fontSize: '5rem',
                lineHeight: '1.3',
                color: '#f5f0e8',
                textShadow: '2px 2px 8px rgba(0,0,0,0.6)'
              }}>
                Your journey, perfected with heart and care
              </h1>
              <p className="animated slideInDown" style={{
                fontFamily: 'Georgia, "Times New Roman", serif',
                fontStyle: 'normal',
                fontWeight: '400',
                fontSize: '2rem',
                lineHeight: '1.3',
                color: '#f5f0e8',
                textShadow: '2px 2px 8px rgba(0,0,0,0.6)',
                marginTop: '1rem'
              }}>
                We go, wherever you go
              </p>
             
            </div>
          </div>
        </div>
      </div>
        
      {/* About Start - UPDATED TEXT COLOR TO BLACK */}
      <div className="container-xxl py-5">
        <div className="container">
          <div className="row g-5">
            <div
              className="col-lg-6 wow fadeInUp"
              data-wow-delay="0.1s"
              style={{ minHeight: 400 }}
            >
              <div className="position-relative h-100">
                <img
                  className="img-fluid position-absolute w-100 h-100"
                  src="assets/img/about.jpg"
                  alt="About Opulent Tours"
                  style={{ 
                    objectFit: "cover",
                    imageRendering: 'crisp-edges',
                    WebkitImageRendering: 'crisp-edges',
                    transform: 'translateZ(0)',
                    backfaceVisibility: 'hidden'
                  }}
                />
              </div>
            </div>
            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.3s">
              <h6 className="section-title bg-white text-start text-primary pe-3">
                About Us
              </h6>
              <h1 className="mb-4">
                Welcome to <span style={{ background: 'linear-gradient(135deg, #876417 0%, #D3A125 30%, #F8D740 50%, #D3A125 70%, #876417 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>Opulent Tours</span>
              </h1>
              <p className="mb-4" style={{ fontSize: '1.25rem', lineHeight: '1.8', color: '#000000', textAlign: 'justify' }}>
                Welcome to Opulent Tours, your gateway to Sri Lanka, a tropical island that captivates travelers with its golden beaches, misty mountains, ancient cities, and the genuine warmth of its people. A land where culture, nature, and adventure blend beautifully, Sri Lanka promises unforgettable experiences at every turn.
              </p>
              <p className="mb-4" style={{ fontSize: '1.25rem', lineHeight: '1.8', color: '#000000', textAlign: 'justify' }}>
                Based in Kalutara, Opulent Tours proudly stands as a leading Sri Lankan travel company, with over 15 years of experience in crafting unforgettable travel experiences. Our young and creative team combines local expertise with modern innovation, ensuring every journey is crafted with care, comfort, and a touch of luxury.
              </p>
              <p className="mb-4" style={{ fontSize: '1.25rem', lineHeight: '1.8', color: '#000000', textAlign: 'justify' }}>
                We design exceptional tours not only across Sri Lanka, but also to India and Thailand, offering everything from exotic getaways and cultural escapes to thrilling adventures. Each itinerary is tailor-made to reflect your style – whether you seek relaxation, exploration, or indulgence.
              </p>
              <p className="mb-4" style={{ fontSize: '1.25rem', lineHeight: '1.8', color: '#086AD8', textAlign: 'justify' }}>
                At Opulent Tours, we believe travel should be as extraordinary as the destinations themselves.
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* About End */}

      {/* Vision, Mission, Values Section - UPDATED TEXT COLOR TO BLACK */}
      <div className="container-xxl py-5">
        <div className="container">
          <div className="text-center mb-4">
            <h2 className="display-5">Our Principles</h2>
            <p style={{ fontSize: '1.25rem', lineHeight: '1.8', color: '#000000' }}>The foundation of our commitment to excellence</p>
          </div>
          <div className="row g-4">
            <div className="col-lg-4 wow fadeInUp" data-wow-delay="0.1s">
              <div className="card h-100 border-0 shadow-sm">
                <div className="card-body p-4">
                  <div className="d-flex align-items-center mb-3">
                    <div className="btn-square bg-primary rounded-circle me-3" style={{ width: '50px', height: '50px' }}>
                      <i className="fa fa-eye text-white"></i>
                    </div>
                    <h4 className="text-primary mb-0">Vision</h4>
                  </div>
                  <p className="card-text" style={{ fontSize: '1.25rem', lineHeight: '1.8', color: '#000000'}}>
                    Turning travel dreams into unforgettable journeys
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 wow fadeInUp" data-wow-delay="0.3s">
              <div className="card h-100 border-0 shadow-sm">
                <div className="card-body p-4">
                  <div className="d-flex align-items-center mb-3">
                    <div className="btn-square bg-primary rounded-circle me-3" style={{ width: '50px', height: '50px' }}>
                      <i className="fa fa-bullseye text-white"></i>
                    </div>
                    <h4 className="text-primary mb-0">Mission</h4>
                  </div>
                  <p className="card-text" style={{ fontSize: '1.25rem', lineHeight: '1.8', color: '#000000' }}>
                    To craft personalized travel experiences with exceptional service, local expertise, and heartfelt care, ensuring every journey becomes an unforgettable memory.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 wow fadeInUp" data-wow-delay="0.5s">
              <div className="card h-100 border-0 shadow-sm">
                <div className="card-body p-4">
                  <div className="d-flex align-items-center mb-3">
                    <div className="btn-square bg-primary rounded-circle me-3" style={{ width: '50px', height: '50px' }}>
                      <i className="fa fa-gem text-white"></i>
                    </div>
                    <h4 className="text-primary mb-0">Values</h4>
                  </div>
                  <ul className="list-unstyled mb-0" style={{ fontSize: '1.25rem', lineHeight: '1.8', color: '#000000'}}>
                    <li className="mb-2"><i className="fa fa-check text-primary me-2"></i>Customer Delight</li>
                    <li className="mb-2"><i className="fa fa-check text-primary me-2"></i>Integrity</li>
                    <li className="mb-2"><i className="fa fa-check text-primary me-2"></i>Passion for Travel</li>
                    <li className="mb-2"><i className="fa fa-check text-primary me-2"></i>Personalized Service</li>
                    <li className="mb-0"><i className="fa fa-check text-primary me-2"></i>Sustainability</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default About